





















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BillingApi } from 'modules/billing/api/billing';
import { BillingModel } from 'modules/billing/classes/billing';
import { SelectOptions } from 'modules/core/interfaces/selectOptions';
import { ElForm } from 'element-ui/types/form';
import AppMessage from 'modules/core/models/appMessage';
import Countries from '@/i18n/en/countries';
import PhoneInput from 'modules/core/components/forms/PhoneInput.vue';

@Component({
  components : {
    PhoneInput,
  },
})
export default class BillingInformation extends Vue {
  public loading: boolean = false;
  public billingFormRules!: any;
  public countries: Array<SelectOptions<string>> = [];

  private billingApi: BillingApi;
  private billingForm: BillingModel;
  private phoneModel = {
    phone: '',
    code: '',
  };

  constructor() {
    super();
    this.billingApi = new BillingApi();
    this.billingForm = new BillingModel();
  }

  public created() {
    this.billingFormRules = {
      Name: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      Address: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      Postcode: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      City: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      Country: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      // PhoneNumber: [
      //   {
      //     trigger: 'blur',
      //     validator: (rule: any, value: string, callback: (error?: Error) => void) => {
      //       if ((this.$refs.phoneInput as PhoneInput).validate()) {
      //         callback();
      //       } else {
      //         callback(new Error(this.$t('forms.wrongPhone') as string));
      //       }
      //     },
      //   },
      // ],
    };
  }

  public async mounted() {
    this.loading = true;

    const user: BillingModel = await this.billingApi.getUser();

    this.billingForm = user;
    // if (user.PhoneNumber) {
    //   this.insertPhoneNumber();
    // }

    for (const item of Object.keys(Countries)) {
      this.countries.push({
        value: item,
        label: this.$t('forms.options.langs.' + item) as string,
      });
    }

    this.loading = false;
  }

  public validateForm() {
    return (this.$refs.billingForm as ElForm).validate();
  }

  public submitForm() {
    (this.$refs.billingForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.billingApi.updateUser(this.billingForm, false).catch((error: Error) => {
          AppMessage.show(this.$t('forms.error', { msg: error }), 'error');
        });
      } else {
        return false;
      }
    });
  }

  // public updatePhoneNumber(val: any) {
  //   this.billingForm.PhoneNumber = val.code + val.phone;
  //   this.phoneModel = val;
  // }

  // public insertPhoneNumber() {
  //   const phoneNumberLenght = this.billingForm.PhoneNumber.length;
  //   this.phoneModel = {
  //     phone: this.billingForm.PhoneNumber.substr(-9),
  //     code: this.billingForm.PhoneNumber.slice(0, phoneNumberLenght - 9),
  //   };
  // }
}
